import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 18l-2 -1l-6 3v-13l6 -3l6 3l6 -3v9","key":"svg-0"}],["path",{"d":"M9 4v13","key":"svg-1"}],["path",{"d":"M15 7v8","key":"svg-2"}],["path",{"d":"M15 19l2 2l4 -4","key":"svg-3"}]]

const IconMapCheck = createReactComponent('outline', 'map-check', 'MapCheck', __iconNode);

export default IconMapCheck;